import script from "./ScorecardImageCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScorecardImageCard.vue?vue&type=script&lang=ts&setup=true"

import "./ScorecardImageCard.vue?vue&type=style&index=0&id=24e4a5b6&lang=postcss&scoped=true"

import exportComponent from "/home/deployment/actions-runner/_work/pwscorecards-vue/pwscorecards-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24e4a5b6"]])

export default __exports__